import { render } from "./OffCanvas.vue?vue&type=template&id=e8bb5c1a&scoped=true"
import script from "./OffCanvas.vue?vue&type=script&lang=js"
export * from "./OffCanvas.vue?vue&type=script&lang=js"

import "./OffCanvas.vue?vue&type=style&index=0&id=e8bb5c1a&scoped=true&lang=css"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/avidvantage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8bb5c1a"]])

export default __exports__